var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStorageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 75,
    viewBox: "0 0 78 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.425 51.5614H16.6237C16.0875 51.5614 15.6487 52.0887 15.6487 52.7333L15.6366 59.7649C15.6366 60.4094 16.0753 60.9368 16.6116 60.9368H61.425C61.9613 60.9368 62.4 60.4094 62.4 59.7649V52.7333C62.4 52.0887 61.9613 51.5614 61.425 51.5614ZM61.425 65.6245H16.5872C16.0509 65.6245 15.6122 66.1519 15.6122 66.7965L15.6 73.8281C15.6 74.4726 16.0387 75 16.575 75H61.425C61.9613 75 62.4 74.4726 62.4 73.8281V66.7965C62.4 66.1519 61.9613 65.6245 61.425 65.6245ZM61.425 37.4982H16.6481C16.1119 37.4982 15.6731 38.0255 15.6731 38.6701L15.6609 45.7017C15.6609 46.3463 16.0997 46.8736 16.6359 46.8736H61.425C61.9613 46.8736 62.4 46.3463 62.4 45.7017V38.6701C62.4 38.0255 61.9613 37.4982 61.425 37.4982ZM74.4047 17.1359L41.2425 0.538366C40.5297 0.182946 39.7656 0 38.9939 0C38.2222 0 37.4581 0.182946 36.7453 0.538366L3.59531 17.1359C1.42594 18.2345 0 20.7835 0 23.6254V73.8281C0 74.4726 0.43875 75 0.975 75H10.725C11.2613 75 11.7 74.4726 11.7 73.8281V37.4982C11.7 34.9199 13.4794 32.8104 15.6731 32.8104H62.3269C64.5206 32.8104 66.3 34.9199 66.3 37.4982V73.8281C66.3 74.4726 66.7388 75 67.275 75H77.025C77.5612 75 78 74.4726 78 73.8281V23.6254C78 20.7835 76.5741 18.2345 74.4047 17.1359Z",
    fill: "#020C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorageIcon);
export default __webpack_public_path__ + "static/media/storage_icon.df1692178c8c50f6aab2c65cbe4eb5ba.svg";
export { ForwardRef as ReactComponent };